/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { cva, cx } from "@panda/css";
import { VStack } from "@panda/jsx";
import { SearchItemsGroup } from "src/hooks";

import { SearchResultItem } from "./SearchResultsItem.element";

const imagesGroupStyle = cva({
	base: {
		"&&": {
			display: "grid",
			alignItems: "start",
			columnGap: "eds.dimension.40",
			rowGap: "eds.dimension.32",
		},
	},
	variants: {
		images: {
			true: {
				gridTemplateColumns: "repeat(2, 1fr)",
				marginBlock: "eds.dimension.40",
				smDown: {
					marginBlock: "eds.dimension.16",
					gridTemplateColumns: "1fr",
				},
			},
			false: {
				gridTemplateColumns: "1fr",
			},
		},
	},
});

type SearchResultsGroupProps = SearchItemsGroup & { keyProp: string };
export const SearchResultsGroup = ({ keyProp, items, images }: SearchResultsGroupProps): React.JSX.Element => {
	return (
		<VStack
			className={cx("search-items-group", imagesGroupStyle({ images }))}
			columnGap="eds.dimension.40"
			rowGap="eds.dimension.24"
			width="full"
		>
			{items?.map((item, i) => (
				<SearchResultItem
					key={`${keyProp}-item-${i}`}
					{...item}
					analytics={{
						eventCategory: "tile",
						eventLabel: item?.title?.text || "",
						eventValue: {
							component: "SearchItemsTitle",
							index: i,
						},
					}}
				></SearchResultItem>
			))}
		</VStack>
	);
};
